import React from 'react';
import { Button, Icon, Modal, Message, Menu, Form, Divider, Tab} from 'semantic-ui-react';
import OutputCheckbox from './OutputCheckbox';
const fileDownload = require('js-file-download');

class CreateOutputFileButton extends React.Component {
  state = {open : false,
           complete : false,
           simID: 0,
           checked : [0,0,0,0,0,0],
           p3dOutput : {"MP3DU_BIN" : '',
                        "OUTPUTS" : [] }};
  
  downloadJSON = this.downloadJSON.bind(this);
  simSelection = this.simSelection.bind(this);
  jsonUpdate = this.jsonUpdate.bind(this);
  onCheck = this.onCheck.bind(this);

  close = () => this.setState({ open : false });
  open  = () => this.setState({ open : true  });

  downloadJSON(e,d) {
    let {checked, simID} = this.state;
    let p3dOutput = {};  //Object.assign({}, this.state.p3dOutput);
    const simulation = this.props.primary['SIMULATIONS'][simID][d.simtype];
    const floatVars = ['TIME_CONVERSION', 'MIN_TIME', 'MAX_TIME', 'TIME_DT'];
    // Add bin name
    p3dOutput['MP3DU_BIN'] = simulation['NAME'] + "_" + d.simtype + ".bin"
    // Remove unchecked
    let finalOut = [];
    for (let i=0; i < checked.length; i++) {
      let outname = Object.keys(this.state.p3dOutput['OUTPUTS'][i])[0];
      let copyObj = {};
      copyObj[outname] = Object.assign({}, this.state.p3dOutput['OUTPUTS'][i][outname]);
      if (checked[i] === 1) { finalOut.push(copyObj) }
    }
    p3dOutput['OUTPUTS'] = finalOut;
    // Add suffixes to file names & remove from object
    for (let i=0; i < p3dOutput['OUTPUTS'].length; i++) {
      let outname = Object.keys(p3dOutput['OUTPUTS'][i])[0];
      let suffix = p3dOutput['OUTPUTS'][i][outname]['suffix'];
      if (suffix !== undefined) {
        delete p3dOutput['OUTPUTS'][i][outname]['suffix'];
        p3dOutput['OUTPUTS'][i][outname]['FILE_NAME'] = p3dOutput['OUTPUTS'][i][outname]['FILE_NAME'] + suffix;
      }
      // Convert number strings to floats
      for (let j=0; j < floatVars.length; j++) {
        if (p3dOutput['OUTPUTS'][i][outname][floatVars[j]] !== undefined) {
          p3dOutput['OUTPUTS'][i][outname][floatVars[j]] = parseFloat(p3dOutput['OUTPUTS'][i][outname][floatVars[j]]);
        }
      }
    }
    const data = JSON.stringify(p3dOutput, null, 2);
    fileDownload(data, 'mp3duOutput.json');
    this.close();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let {checked} = prevState;
    if (nextProps.primary['SIMULATIONS'].length > 0 & Math.max.apply(null, checked) > 0) {
      // Catch if active sim becomes endpoint and remove checks
      if (Object.keys(nextProps.primary['SIMULATIONS'][prevState.simID])[0] === "ENDPOINT") {
        // Arrays are so dumb
        for (let i=0; i < 3; i++) {
          checked[i] = 0;
        }
        return({checked : checked});
      }
    }
    // Catchall
    return null;
  }

  simSelection(e,d) {
    // Only updates if simID changes
    if (d.value !== this.state.simID) {
      let {checked} = this.state;
      checked.fill(0);
      this.setState({simID : d.value,
                     checked : checked,
                     p3dOutput : {"MP3DU_BIN" : '',
                                  "OUTPUTS" : [] }});
    }
  }

  onCheck(e,d) {
    let complete = false
    const {checked} = this.state;
    // Flip binary
    checked[d.id] = checked[d.id] === 1 ? 0 : 1;
    // If 1 or more checked, complete
    if (Math.max(...checked) > 0) { complete = true }
    this.setState({checked : checked,
                   complete : complete});
  }

  jsonUpdate(e, d) {
    let update = this.state.p3dOutput;
    if (d.value !== null) {
      // Prepare update object
      let obj = {}
      obj[d.name] = d.value;
      // Does it exist yet?
      if (update['OUTPUTS'][d.id] === undefined) {
        update['OUTPUTS'].push(obj);
      } else {
        update['OUTPUTS'][d.id] = obj;
      }
    } else {
      // There is no remove anymore
      //delete update['OUTPUTS'][d.name];
    }
    this.setState({p3dOutput : update});
  }

  render() {
    const {open, complete, p3dOutput, simID} = this.state;
    // Get Simulations, their names, and their types
    const simulations = this.props.primary['SIMULATIONS'];
    const outputDisabled = simulations.length > 0 ? false : true;
    let simTypes = [];
    let simNames = [];

    //console.log('Current p3dOutput:',p3dOutput);
    //console.log(simulations);

    for (let i=0; i < simulations.length; i++) {
      simTypes.push(Object.keys(simulations[i])[0]);
      let name = simulations[i][simTypes[i]]["NAME"] === undefined ? 'NONAME' : simulations[i][simTypes[i]]["NAME"];
      simNames.push(name);
    }
    const currOut = p3dOutput['OUTPUTS'];
    const currCheck = this.state.checked;
    const currName = simNames[simID];
    const currType = simTypes[simID];
    const endpoint = currType === 'PATHLINE' ? false : true;

    // Make lists
    const simDD = simNames.map((lab,index) =>
      ({key: index, text: lab, value: index}));
    
    // Cause PANE
    const panes = [
      { menuItem: 'Shapefiles', pane: (
        <Tab.Pane key='tab1'>
          <OutputCheckbox label='Pathline Whole' name='PATHLINE_WHOLE' named convert max min suffix='.shp'
                          data={currOut} onChange={this.jsonUpdate} simname={currName} disabled={endpoint}
                          onCheck={this.onCheck} id={0} checked={currCheck[0] === 1} />

          <OutputCheckbox label='Pathline Parts' name='PATHLINE_PARTS' named convert max min suffix='.shp'
                          data={currOut} onChange={this.jsonUpdate} simname={currName} disabled={endpoint}
                          onCheck={this.onCheck} id={1} checked={currCheck[1] === 1}/>

          <OutputCheckbox label='Points in Time' name='POINTS_IN_TIME' named convert dt suffix='.shp'
                          data={currOut} onChange={this.jsonUpdate} simname={currName} disabled={endpoint}
                          onCheck={this.onCheck} id={2} checked={currCheck[2] === 1} />

          <OutputCheckbox label='Endpoints' name='ENDPOINT' named suffix='.shp'
                          data={currOut} onChange={this.jsonUpdate} simname={currName}
                          onCheck={this.onCheck} id={3} checked={currCheck[3] === 1} />
        </Tab.Pane>
        )
      },
      { menuItem: 'Tables', pane: (
        <Tab.Pane key='tab2' >
          <OutputCheckbox label='Text File (ASCII) Table' name='ASCII_TABLE' named suffix='.dat'
                          data={currOut} onChange={this.jsonUpdate} simname={currName}
                          onCheck={this.onCheck} id={4} checked={currCheck[4] === 1} />

          <OutputCheckbox label='DBF Table' name='DBF_TABLE' named suffix='.dbf'
                          data={currOut} onChange={this.jsonUpdate} simname={currName}
                          onCheck={this.onCheck} id={5} checked={currCheck[5] === 1} />
        </Tab.Pane>
        )
      }
    ];

    // CSS Fix
    const inlineStyle = {
      modal : {
        position: 'fixed',
        width: '80%',
        top: '10%',
        left: '10%',
        overflowY: 'auto',
        maxWidth: '1200px'
      }
    };

    return(
      <div>
      <Menu.Item disabled={outputDisabled} onClick={this.open}>
        <Icon name="line graph" /> WriteP3DOutput File
      </Menu.Item>

      <Modal dimmer='inverted' open={open} onClose={this.close} style={inlineStyle.modal}>
        <Modal.Header><Icon name="file code" />Create WriteP3DOutput Input File</Modal.Header>
        <Modal.Content>
          <Message>WriteP3DOutput.exe is a post-processing program to write commonly used output file types 
          (e.g. shapefiles, text files) from the binary file produced by mod-PATH3DU.
          Use this window to generate the JSON input file required by WriteP3DOutput.</Message>

          <Form.Dropdown label='Select a Simulation: ' inline options={simDD}
                          onChange={this.simSelection} name="simName" types={simTypes} defaultValue={0}/>

          <Divider />

          <Tab menu={{ fluid: true, vertical: true, tabular: false, pointing: true}} panes={panes} renderActiveOnly={false} />


        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={this.close} icon>Close <Icon name="close" /></Button>
          <Button color="green" onClick={this.downloadJSON} simtype={currType} icon disabled={!complete}>
            Download <Icon name="save" /></Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

export default CreateOutputFileButton;